import React, { useEffect, useState  } from "react";
import { useNavigate } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import { auth, logout, getData } from "../../configs/firebase";
import { onAuthStateChanged } from "firebase/auth";

import LodingIndicator from "../../components/LoadingIndicator"

import { IMAGES } from "../../constants/index"

import './FaithPage.css';


function FaithPage(){
    let navigate = useNavigate();

    const [user, setUser] = useState(null);
    const [opacity, setOpacity] = useState(0);
    const [isLoaded, setIsLoaded] = useState(false);

    // 🔹 로그인 상태 감지
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            if(currentUser) setUser(currentUser);
            else handlelogout()
        });
        return () => unsubscribe();
    }, []);

    // 🔹 첫 시작 시 페이드 인 적용
    useEffect(() => {
        if(user){
            getUserData()
        }
    }, [user]);

    const getUserData = async () => {
        const data = await getData(user.uid)
        validateDate(data[0].lastestUpdateDate)
    }
    
    const handleBack = () => {
        setOpacity(0);
        setTimeout(() => {
            navigate('/myFaith');
        }, 2000);
    }
    const handlelogout = async() => {
        await logout()
        navigate('/login');
    }
    const handleNavigation = (addrss) => {
        navigate(addrss);
    }
    

    function ExternalPage(addrss) {
        // console.log(NOTION,dayIndex,NOTION[dayIndex],addrss)
        return (
            <div style={{ width: "100%", height: "100%" }}>
                {!isLoaded && (
                    <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", fontSize: "18px", color: "#555" }}>
                        <LodingIndicator visiblity={true} color={"#131835"} />
                    </div>
                )}
                <iframe src={addrss} width="100%" height="100%" frameborder="0" onLoad={() => setIsLoaded(true)} allowfullscreen />
            </div>
        );
    }
    function validateDate(updatedDate) {
        if (!updatedDate) {
            setOpacity(1);
            return false;
        }
    
        // 🔹 1. 한국 시간(KST) 기준 오늘 날짜 가져오기
        const today = new Date().toLocaleDateString("ko-KR", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        }).replace(/. /g, "-").replace(".", ""); // ✅ "2025-02-22" 형식으로 변환
    
        // 🔹 2. updatedDate에서 날짜 부분만 추출 (예: "2025. 02. 22." → "2025-02-22")
        const updatedDateString = updatedDate.split(" ")[0].replace(/. /g, "-").replace(".", "");
    
    
        // 🔹 3. 날짜 비교 후 결과 반환
        if (today === updatedDateString) {
            // console.log("✅ 오늘 날짜와 동일!");
            setOpacity(1);
            setTimeout(() => {
                // handleNavigation('/myFaith')
            }, 2000);
            return true;
        } else {
            setTimeout(() => {
                setOpacity(1);
            }, 500); // 0.5초 후 페이드 인
        }
    }

    return (
        <div
            className="wrap"
            style={{
                backgroundImage: `url(${IMAGES.BACKGROUMND})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                width: "100vw",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <div className="faithWrap" style={{ opacity, transition: "opacity 1s ease-in-out" }}>
                <div className="contentsTitle">
                    <span className="iconButton" onClick={handleBack}>
                        <FontAwesomeIcon className="iconBtn" icon={faArrowLeft} style={{color:"#131835"}}/>
                    </span>
                    <span>믿음대로 캠페인이란?</span>
                    <span className="iconButton"></span>
                </div>    
                <div className="contents">
                    {ExternalPage("https://instinctive-time-66e.notion.site/ebd/1a299e2dae3880a18698efcf06b748fd")}
                </div>       
            </div>
        </div>
    );
  }
  export default FaithPage;